import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: "app-welcome",
    templateUrl: "./welcome.component.html",
    styleUrls: ["./welcome.component.scss"],
    standalone: false
})
export class WelcomeComponent implements OnInit {
  public hash: string | null = "";
  public error = 0;
  public done = false;
  public loading: boolean = false;
  public passwordForm: UntypedFormGroup;
  public inputType = "password";

  constructor(
    protected formBuilder: UntypedFormBuilder,
    protected router: Router,
    protected authService: AuthService,
    protected route: ActivatedRoute,
  ) {
    this.hash = this.route.snapshot.paramMap.get("hash");
  }

  ngOnInit(): void {
    this.passwordForm = this.formBuilder.group({
      password: [null, Validators.required],
      passwordConfirm: [null, Validators.required],
    });
  }

  public toggleShowPassword(): void {
    if (this.inputType == "password") {
      this.inputType = "text";
    } else {
      this.inputType = "password";
    }
  }

  public saveAction(): void {
    if (!this.hash) {
      return;
    }

    this.error = 0;
    const values = this.passwordForm.getRawValue();
    if (values.password != values.passwordConfirm) {
      this.error = 1;
      return;
    }

    this.loading = true;
    this.authService.setPassword(values.password, this.hash).subscribe((done) => {
      if (done) {
        this.router.navigateByUrl("/");
        return;
      }
      this.error = 2;
      this.loading = false;
    });
  }
}
